import { formatValidQueryParamUrlCommaSeparated } from "utils/common";

import { emptySplitApi } from "./empty-split-api";
import {
  ProductCategoriesFilters,
  ProductCategory,
  ProductCategoryCreateInput,
  ProductCategoryUpdateInput
} from "./types/product-categories.type";

const productCategoriesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductCategories: builder.query<
      ProductCategory[],
      ProductCategoriesFilters | void
    >({
      // Without `limit` the endpoint returns every category as a plain array.
      query: (filters) =>
        `/product-categories/?${formatValidQueryParamUrlCommaSeparated({
          include_archived: filters?.include_archived || undefined
        })}`,
      providesTags: ["ProductCategories"]
    }),
    createProductCategory: builder.mutation<
      ProductCategory,
      ProductCategoryCreateInput
    >({
      query: (body) => ({
        url: "/product-categories/",
        method: "POST",
        body
      }),
      invalidatesTags: ["ProductCategories"]
    }),
    updateProductCategory: builder.mutation<
      ProductCategory,
      ProductCategoryUpdateInput
    >({
      query: ({ id, ...body }) => ({
        url: `/product-categories/${id}/`,
        method: "PATCH",
        body
      }),
      invalidatesTags: ["ProductCategories"]
    }),
    reorderProductCategories: builder.mutation<
      ProductCategory[],
      { ids: number[] }
    >({
      query: (body) => ({
        url: "/product-categories/reorder/",
        method: "POST",
        body
      }),
      invalidatesTags: ["ProductCategories"]
    })
  })
});

export const {
  useGetProductCategoriesQuery,
  useCreateProductCategoryMutation,
  useUpdateProductCategoryMutation,
  useReorderProductCategoriesMutation
} = productCategoriesApi;
